import "../../shared/styles/UnifiedTable.css";

const Tabla = ({ data, setModalPuntoVenta, setSelect }) => {

  const onClick = (e, value) => {
    switch (e.target.name) {
      case "modal_punto_venta":{
        setModalPuntoVenta(true);
        setSelect(value);
      }break;
    }
  }

  return (
    <div className="min-vh-100">
      <div className="unified-table-container">
        <table className="unified-table">
          <thead>
            <tr>
              <th className="text-center"><div>Id</div></th>
              <th className="text-start"><div>Nombre</div></th>
              <th className="text-start"><div>Provincia</div></th>
              <th className="text-start"><div>Ciudad</div></th>
              <th className="text-start"><div>Dirección</div></th>
              <th className="text-center"><div>Monto Límite / Créditos</div></th>
              <th className="text-center"><div>Estado</div></th>
              <th className="text-center"><div>Acciones</div></th>
            </tr>
          </thead>
          <tbody>
            {data.map((venta) => (
              <tr key={venta.id}>
                <td className="text-center">{venta.id}</td>
                <td className="text-start">
                  <span className="unified-table-link" style={{ cursor: 'default' }}>
                    {venta.nombre}
                  </span>
                </td>
                <td className="text-start">{venta.provincia}</td>
                <td className="text-start">{venta.ciudad}</td>
                <td className="text-start">{venta.direccion}</td>
                <td className="text-center">
                  <span className="unified-money">
                    $ {new Intl.NumberFormat('de-DE').format(venta.limite_credito)}
                  </span>
                </td>
                <td className="text-center">
                  <span className={`unified-badge ${
                    venta.status === 'Activo' ? 'unified-badge-success' :
                    venta.status === 'Inactivo' ? 'unified-badge-danger' :
                    'unified-badge-secondary'
                  }`}>
                    {venta.status}
                  </span>
                </td>
                <td className="text-center">
                  <button
                    className="btn btn-sm"
                    style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: '#ffffff',
                      borderRadius: '8px',
                      padding: '8px 16px',
                      border: 'none',
                      fontWeight: '500'
                    }}
                    name="modal_punto_venta"
                    onClick={(event) => onClick(event, venta)}
                  >
                    <i className="bi bi-pencil-fill me-2"></i>
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Tabla;
